import { render } from "./TokenManagement.vue?vue&type=template&id=1d594875&scoped=true&ts=true"
import script from "./TokenManagement.vue?vue&type=script&lang=ts"
export * from "./TokenManagement.vue?vue&type=script&lang=ts"

import "./TokenManagement.vue?vue&type=style&index=0&id=1d594875&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d594875"]])

export default __exports__